import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatButtonModule, MatDialogModule } from '@angular/material';

import { ViegaLogoComponent } from './components/viega-logo/viega-logo.component';
import { ViegaHeaderComponent } from './components/viega-header/viega-header.component';
import { ViegaButtonComponent } from './components/viega-button/viega-button.component';
import { ViegaIconButtonComponent } from './components/viega-icon-button/viega-icon-button.component';
import { ViegaStartPageComponent } from './components/viega-start-page/viega-start-page.component';
import { ViegaCardComponent } from './components/viega-card/viega-card.component';
import { ViegaRadioButtonComponent } from './components/viega-radio-button/viega-radio-button.component';
import { ViegaCheckboxComponent } from './components/viega-checkbox/viega-checkbox.component';
import { ViegaSliderComponent } from './components/viega-slider/viega-slider.component';
import { ViegaDialogWrapperComponent } from './components/viega-dialog-wrapper/viega-dialog-wrapper.component';
import { ViegaImageGalleryComponent } from './components/viega-image-gallery/viega-image-gallery.component';
import { ViegaImageDialogComponent } from './components/viega-image-dialog/viega-image-dialog.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { CookieHintBoxComponent } from './components/cookie-hint-box/cookie-hint-box.component';
import { CollapsiblePanelComponent } from './components/collapsible-panel/collapsible-panel.component';
import { PanelHeaderComponent } from './components/collapsible-panel/panel-header/panel-header.component';
import { PanelFilterCategoryComponent } from './components/collapsible-panel/panel-filter-category/panel-filter-category.component';
import { ItemScrollboxComponent } from './components/item-scrollbox/item-scrollbox.component';
import { GenericDecisionDialogComponent } from './components/generic-decision-dialog/generic-decision-dialog.component';
import { ViegaColorPickerComponent } from './components/viega-color-picker/viega-color-picker.component';
import { MeasureInputComponent } from './components/measure-input/measure-input.component';
import { LocalFileInputComponent } from './components/local-file-input/local-file-input.component';

import { LoadingStateService } from "./services/loading-state-service";

import { TrustHtmlPipe } from "./pipes/trust-html.pipe";
import { StringReplacePipe } from './pipes/string-replace.pipe';

import { MinMaxValidator } from './validators/MinMaxValidator';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatButtonModule,
        MatDialogModule,
        FormsModule,
    ],
    declarations: [
        ViegaLogoComponent,
        ViegaHeaderComponent,
        ViegaButtonComponent,
        ViegaIconButtonComponent,
        ViegaStartPageComponent,
        ViegaCardComponent,
        ViegaRadioButtonComponent,
        ViegaCheckboxComponent,
        ViegaSliderComponent,
        ViegaDialogWrapperComponent,
        ViegaImageGalleryComponent,
        ViegaImageDialogComponent,
        ViegaColorPickerComponent,
        LoadingSpinnerComponent,
        GenericDecisionDialogComponent,
        MeasureInputComponent,
        LocalFileInputComponent,
        CookieHintBoxComponent,
        CollapsiblePanelComponent,
        PanelHeaderComponent,
        PanelFilterCategoryComponent,
        ItemScrollboxComponent,

        TrustHtmlPipe,
        StringReplacePipe,

        MinMaxValidator,
    ],
    exports: [
        ViegaLogoComponent,
        ViegaHeaderComponent,
        ViegaButtonComponent,
        ViegaIconButtonComponent,
        ViegaStartPageComponent,
        ViegaCardComponent,
        ViegaRadioButtonComponent,
        ViegaCheckboxComponent,
        ViegaSliderComponent,
        ViegaDialogWrapperComponent,
        ViegaImageGalleryComponent,
        ViegaImageDialogComponent,
        ViegaColorPickerComponent,
        LoadingSpinnerComponent,
        GenericDecisionDialogComponent,
        MeasureInputComponent,
        LocalFileInputComponent,
        CookieHintBoxComponent,
        CollapsiblePanelComponent,
        PanelHeaderComponent,
        PanelFilterCategoryComponent,
        ItemScrollboxComponent,

        TrustHtmlPipe,
        StringReplacePipe,

        MinMaxValidator,
    ],
    providers: [
        LoadingStateService,
    ],
    entryComponents: [
        ViegaImageDialogComponent,
        GenericDecisionDialogComponent,
    ]
})
export class ViegaCommonModule {}



// WEBPACK FOOTER //
// ./src/viega-common/viega-common.module.ts